import { SaleExportProp, SalesLineExportProp } from 'gen/ApiClient';
import React from 'react';

interface IViewContext {
	exportRecord: Record<SaleExportProp, string>;
	linesExportRecord: Record<SalesLineExportProp, string>;
}

export const SalesListViewContext = React.createContext<IViewContext>(undefined as any);
